import React, { useState, useContext } from 'react'
import CustomImage from './Image'
import Details from './Details'
import { useRouter } from 'next/router'
import Buttons from './Buttons'
import { ItemCardManger } from '@components/Cards/BidItem'
import { getCardBackgroundColor } from '@components/Cards/BidItem/utilities/getColors'
import BidIncrementModal from '../shared/BidIncrementModal'
import BidTrashIcon from 'elements/BidTrashIcon/BidTrashIcon'
import { DeleteBidItem } from '../shared/DeleteBidItem'
import ItemClosed from '../shared/ItemClosed'

const ListView = () => {
  const {
    item: { id, itemClosed, bidStatus, auctionId, removed },
    handlers: { handleSelectItems, linkMiddleWare, handleDeleteItem },
    options: { isWatchlistPage },
  } = useContext<any>(ItemCardManger)
  const [loadingBid, setLoadingBid] = useState(false)
  const [incrementModalVisible, setIncrementModalVisible] = useState(false)
  const router = useRouter()

  const cardBackground = getCardBackgroundColor(itemClosed, bidStatus)
  return (
    <div className={'flex flex-row items-center'}>
      <div
        className={`h-38 w-full flex
                    overflow-hidden rounded-xl border border-bidfta-gray-border
                    shadow-md hover:shadow-xl transition duration-300 ease-in-out ${cardBackground}`}
        onClick={() => {
          if (linkMiddleWare) {
            linkMiddleWare()
          }
          router.push(`/${auctionId}/item-detail/${id}`)
        }}
        tabIndex={0}
        role="button"
        aria-label="Click to navigate to item details"
        onKeyDown={(e) => {
          if (linkMiddleWare) {
            linkMiddleWare()
          }
          e.key === 'Enter' && router.push(`/${auctionId}/item-detail/${id}`)
        }}
      >
        <CustomImage />

        <BidIncrementModal
          visible={incrementModalVisible}
          itemId={id}
          setVisible={setIncrementModalVisible}
          containerStyle="h-full bg-black/20"
        />
        <ItemClosed
          visible={removed}
          id={id}
          auctionId={auctionId}
          containerStyle="h-full bg-gray-400/90 border-radius-2 rounded-lg"
        />
        <div className="w-full px-6 py-7 text-xs flex flex-row items-center justify-between">
          <Details
            loadingBid={loadingBid}
            setIncrementModalVisible={setIncrementModalVisible}
          />

          <Buttons loadingBid={loadingBid} setLoadingBid={setLoadingBid} />
        </div>
      </div>
      {isWatchlistPage && (
        <div
          className="cursor-default shrink ml-2"
          onClick={(e) => e.stopPropagation()}
        >
          <input
            type="checkbox"
            className="w-4 h-4 cursor-pointer"
            onClick={(e: any) => {
              e.stopPropagation()
              handleSelectItems(id)
            }}
          />

          <DeleteBidItem handleDeleteItem={handleDeleteItem} id={id} />
        </div>
      )}
    </div>
  )
}

export default ListView
